import Vue from "vue";
import Router from "vue-router";
import firebase from "firebase";
import store from "./store/index.js";

/* First Rental Page */
import Rental from "@/pages/Rental/Rental.vue";

// TODO- move rental out of page

Vue.use(Router);

const router = new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Rental
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.meta.requiresAuth ? to.meta.requiresAuth : false;
  let currentUser = store.state.currentUser;

  if (to.path === "/logout") {
    console.log("triggering logout");
    store.dispatch("dispatchSignout");
    return next("/login");
  }
  // during page reload, store is set to null
  console.log(currentUser);
  if (!currentUser) {
    console.log("calling firebase");
    currentUser = await firebase.auth().currentUser;
    console.log(currentUser);
  }

  if (requiresAuth && !currentUser) {
    return next("/");
  } else if (!requiresAuth && currentUser) {
    return next("/dashboard");
  } else return next();
});
Vue.use(Router);

export default router;
